export enum SubportionTypeEnum {
    SLIDE = 'SLIDE',
    STERILE_TUBE = 'STERILE_TUBE',
    GRILLE = 'GRILLE'
}

export interface CommonSubportionTypeResponse {
    sptId: number
    subportionTypeEnum: SubportionTypeEnum
    sptName: string
    sptActive: boolean
    sptOriginalName: string
}
